<template>
	<div class="product-details">
		<div v-if="productDetails.length > 0">
			<div class="details-top">
				<img src="../../assets/imgs/dalis.png" alt="" />
				<h1>{{ productDetails[0].productName }}</h1>
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">{{
						$t("menuList.home")
					}}</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/product' }">{{
						$t("menuList.products")
					}}</el-breadcrumb-item>
					<el-breadcrumb-item class="is-link-itself">{{
						$t("productdetail")
					}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<tftcom
				:dataList="productDetails"
				:dataImg="AboutProduct"
				v-if="$route.query.productType === 'TFT'"
			></tftcom>
			<div v-else>
				<div class="details-content">
					<div class="details-img">
						<div
							id="small-img-box"
							@mouseover="mouseoverEvent"
							@mousemove="mousemoveEvent($event)"
							@mouseout="mouseoutEvent"
						>
							<div class="float-box"></div>
							<img
								id="small-img"
								:src="
									`${$queryUrl}${productDetails[0].productImage}`
								"
							/>
						</div>
						<div v-show="showBigImg" id="big-box">
							<img
								id="big-img"
								:src="
									`${$queryUrl}${productDetails[0].productImage}`
								"
							/>
						</div>
					</div>
					<div class="details-text">
						<h3>{{ productDetails[0].productName }}</h3>
						<div>{{ $t("detail") }}</div>
						<ul>
							<li
								v-for="(item, index) in explainList"
								:key="index"
							>
								{{ item }}
							</li>
						</ul>
						<!-- <div>
              <label>{{ $t("product.size") }}</label>
              <span
                >{{ productDetails[0].diagonalScreenSize
                }}{{ $t("product.inch") }}</span
              >
            </div>
            <div>
              <label>{{ $t("product.resolving") }}</label>
              <span>{{ productDetails[0].numberOfPixels }}</span>
            </div>
            <div>
              <label>{{ $t("product.color") }}</label>
              <span>{{ productDetails[0].colorDepth }}</span>
            </div>
            <div>
              <label>{{ $t("product.glass") }}</label>
              <span>{{ productDetails[0].panelSize }}</span>
            </div>
            <div>
              <label>{{ $t("product.Visual") }}</label>
              <span>{{ productDetails[0].activeArea }}</span>
            </div>
            <div>
              <label>{{ $t("product.interface") }}</label>
              <span>{{ productDetails[0].productInterface }}</span>
            </div>
            <div>
              <label>{{ $t("product.Drive") }}</label>
              <span>{{ productDetails[0].driveIc }}</span>
            </div>
            <div>
              <label>{{ $t("product.glass") }}</label>
              <span>{{ productDetails[0].assembly }}</span>
            </div> -->
					</div>
				</div>

				<el-table border :data="tableData" style="width: 100%">
					<el-table-column width="100">
						<i class="el-icon-arrow-right"></i>
					</el-table-column>
					<el-table-column prop="label" label="Diagonal Size">
					</el-table-column>
					<el-table-column
						:label="`${productDetails[0].diagonalScreenSize}''`"
					>
						<template slot-scope="scope">
							{{ productDetails[0][scope.row.key] }}
						</template>
					</el-table-column>
				</el-table>
			</div>

			<!-- <div class="details-drawing">
        <div class="products-other">
          <div class="product-title">{{ $t("product.about") }}</div>
          <nuxt-link
            v-for="(item, index) in AboutProduct"
            :key="index"
            :to="{
              path: 'product-id',
              params: { id: item.productName },
              query: item
            }"
            target="_blank"
          >
            <div class="img-box">
              <img v-lazy="`${$queryUrl}${item.productImage}`" alt="" />
              <span>{{ item.productName }}</span>
            </div>
          </nuxt-link>
        </div>
        <div class="product-info">
          <div class="product-title">{{ $t("product.information") }}</div>
          <div>
            <img v-lazy="`${$queryUrl}${productDetails[0].content}`" alt="" />
          </div>
        </div>
        <div class="products-drawing">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="产品信息" name="first">
            <img src="../../assets/imgs/logo.png" alt="" />
            <el-form ref="form" :model="form" label-width="80px">
              <div class="title">产品留言</div>
              <el-form-item label="名字">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="电话">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="内容">
                <textarea name="" id="" cols="30" rows="10"></textarea>
              </el-form-item>
              <el-button type="warning">请留言</el-button>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      </div> -->
		</div>
		<div class="nodata" v-else>
			<img src="../../assets/imgs/nodata.png" alt="" />
		</div>
	</div>
</template>
<script>
import tftcom from "../../components/tftDetails";
export default {
	components: { tftcom },
	data() {
		return {
			activeName: "first",
			form: {
				name: "",
				region: "",
				date1: "",
				date2: "",
				delivery: false,
				type: [],
				resource: "",
				desc: "",
				query: null,
			},
			AboutProduct: [],
			productDetails: [],
			showBigImg: false,
			bigImg: null,
			smallImg: null,
			explainList: this.$t("explainList"),
			tableData: [
				{ label: "Pixel No.", key: "numberOfPixels" },
				{ label: "Color Depth", key: "colorDepth" },
				{ label: "Panel Size(mm)", key: "panelSize" },
				{ label: "Active area(mm)", key: "activeArea" },
				{ label: "Pixel Pitch", key: "pixelPitch" },
				{ label: "Interface", key: "productInterface" },
			],
		};
	},
	computed: {
		productId() {
			return this.$store.state.productId;
		},
	},
	created() {
		this.getProductList();
	},
	methods: {
		handleClick() {},
		getProductList() {
			this.$axios
				.post(`selectProductInfoById`, this.$route.query)
				.then((res) => {
					this.productDetails = res.data.data;
					this.AboutProduct = this.productDetails[0].productImage.split(
						"##"
					);
				});
		},
		mouseoverEvent() {
			console.log(13456);
			this.showBigImg = true;
			this.objFloatBox = document.getElementsByClassName("float-box")[0];
			this.objDemo = document.getElementsByClassName("details-img")[0];
			this.objSmallBox = document.getElementById("small-img-box");
			this.objFloatBox = document.getElementsByClassName("float-box")[0];
			this.objBigBox = document.getElementById("big-box");
			this.objBigBoxImage = document.getElementById("big-img");
			this.objFloatBox.style.display = "block";
		},
		mousemoveEvent(e) {
			this.$nextTick(() => {
				var _event = e || window.event;
				var left =
					_event.clientX -
					this.objDemo.offsetLeft -
					this.objSmallBox.offsetLeft -
					this.objFloatBox.offsetWidth / 2;
				var top =
					_event.clientY -
					this.objDemo.offsetTop -
					this.objSmallBox.offsetTop -
					this.objFloatBox.offsetHeight / 2;
				if (left < 0) {
					left = 0;
				} else if (
					left >
					this.objSmallBox.offsetWidth - this.objFloatBox.offsetWidth
				) {
					left =
						this.objSmallBox.offsetWidth -
						this.objFloatBox.offsetWidth;
				}
				if (top < 0) {
					top = 0;
				} else if (
					top >
					this.objSmallBox.offsetHeight -
						this.objFloatBox.offsetHeight
				) {
					top =
						this.objSmallBox.offsetHeight -
						this.objFloatBox.offsetHeight;
				}
				/* 放大镜的位置 */
				this.objFloatBox.style.left = left + "px";
				this.objFloatBox.style.top = top + "px";
				/* 计算百分比 */
				var percentX =
					left /
					(this.objSmallBox.offsetWidth -
						this.objFloatBox.offsetWidth);
				var percentY =
					top /
					(this.objSmallBox.offsetHeight -
						this.objFloatBox.offsetHeight);
				/* 显示图片相对应位置 */
				this.objBigBoxImage.style.left =
					-percentX *
						(this.objBigBoxImage.offsetWidth -
							this.objBigBox.offsetWidth) +
					"px";
				this.objBigBoxImage.style.top =
					-percentY *
						(this.objBigBoxImage.offsetHeight -
							this.objBigBox.offsetHeight) +
					"px";
			});
		},
		mouseoutEvent() {
			this.showBigImg = false;
			this.objFloatBox.style.display = "none";
		},
	},
};
</script>
<style lang="scss">
.product-details {
	width: 1200px;
	margin: auto;
	.details-top {
		height: 200px;
		padding: 24px 0;
		text-align: center;
		img {
			margin: 0 auto;
		}
		h1 {
			padding: 24px 0;
		}
		.is-link-itself .el-breadcrumb__inner {
			font-weight: 600;
			color: #409eff;
		}
		.el-breadcrumb__inner a,
		.el-breadcrumb__inner.is-link {
			font-weight: 400;
		}
	}
	.details-content {
		display: flex;
		.details-img {
			width: 400px;
			border: 1px solid #ccc;
			position: relative;

			#small-img-box {
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				// cursor: url("../../assets/imgs/big.png"), auto;
				.float-box {
					display: none;
					width: 160px;
					height: 120px;
					position: absolute;
					background: #ffffcc;
					border: 1px solid #ccc;
					opacity: 0.5;
					pointer-events: none;
				}
				img {
					width: 100%;
				}
			}
			#big-box {
				position: absolute;
				width: 100%;
				height: 100%;
				left: 101%;
				top: 0;
				border: 1px solid #ccc;
				background: #fff;
				overflow: hidden;
				#big-img {
					position: absolute;
					left: 0;
					top: 0;
				}
			}
		}
		.details-text {
			flex: 1;
			line-height: 30px;
			padding: 0 24px;
			border-bottom: 1px dashed #ccc;
			text-align: left;
			h3 {
				font-size: 20px;
				font-weight: 600;
				margin-bottom: 10px;
			}
			label {
				font-size: 14px;
				font-weight: 600;
				display: inline-block;
				width: 120px;
			}
			ul {
				padding: 0 40px;
				li {
					list-style-type: disc;
				}
			}
		}
	}
	.el-table {
		margin: 40px 0;
		th {
			background: #f5f7fa;
		}
	}

	// .details-drawing {
	//   display: flex;
	//   margin-top: 24px;
	//   margin-bottom: 60px;
	//   .products-other {
	//     width: 220px;
	//     .img-box {
	//       border: 1px solid #ccc;
	//       text-align: center;
	//       margin-top: 10px;
	//       padding-bottom: 12px;
	//       img {
	//         width: 200px;
	//       }
	//     }
	//   }
	//   .product-title {
	//     font-size: 18px;
	//     line-height: 32px;
	//     margin-bottom: 10px;
	//     font-weight: 600;
	//     img {
	//       width: 100%;
	//     }
	//   }
	//   .product-info {
	//     margin-left: 26px;
	//     flex: 1;
	//     div:nth-child(2) {
	//       border: 1px solid #ccc;
	//       min-height: 500px;
	//     }
	//   }
	//   .products-drawing {
	//     flex: 1;
	//     .el-form {
	//       width: 600px;
	//       background: #f9f9f9;
	//       padding: 16px 24px 16px 0;
	//       .title {
	//         font-size: 30px;
	//         padding-bottom: 16px;
	//         text-align: center;
	//       }
	//       textarea {
	//         width: 100%;
	//         border-color: #dcdfe6 !important;
	//         border-radius: 4px;
	//         &:hover {
	//           border-color: #c0c4cc;
	//         }
	//       }
	//     }
	//   }
	// }
}
.nodata {
	flex: 1;
	text-align: center;
	line-height: 400px;
	img {
		width: 100px;
	}
}
</style>
